var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { noop } from 'lodash';
import { Alert } from 'reactstrap';
import { stringBuilder } from '../util';
export const AlertVariant = {
    Secondary: 'secondary',
    Success: 'success',
    Info: 'info',
    Warning: 'warning',
    Danger: 'danger'
};
export const AriaLiveType = {
    Off: 'off',
    Polite: 'polite',
    Assertive: 'assertive'
};
const TuxAlert = (props) => {
    const { ariaLive, children, className, dismissible = false, heading, onClose = noop, type = AlertVariant.Secondary } = props, rest = __rest(props, ["ariaLive", "children", "className", "dismissible", "heading", "onClose", "type"]);
    const [isVisible, setIsVisible] = useState(true);
    const [fadeout, setFadeout] = useState(false);
    let renderAlert;
    const classes = stringBuilder(`alert alert-${type} fade show`, { 'alert-dismissible': dismissible }, { 'fade-out': fadeout }, className);
    const renderAlertMessage = () => {
        return (_jsxs("div", Object.assign({ className: "alert-message" }, { children: [heading && _jsx("h4", Object.assign({ className: "alert-heading" }, { children: heading }), void 0), children] }), void 0));
    };
    const handleToggle = () => {
        if (ariaLive) {
            setFadeout(true);
            setTimeout(() => {
                setIsVisible(false);
            }, 150);
        }
        else {
            setIsVisible(false);
        }
        onClose();
    };
    const TuxAccessibleAlert = () => {
        return isVisible ? (_jsxs("div", Object.assign({ "aria-live": ariaLive, className: classes, color: type, role: ariaLive === AriaLiveType.Assertive ? 'alert' : 'note' }, rest, { children: [dismissible && (_jsx("button", { "aria-label": 'Close', className: "close", onClick: handleToggle, type: "button" }, void 0)), renderAlertMessage()] }), void 0)) : null;
    };
    if (ariaLive) {
        renderAlert = _jsx(TuxAccessibleAlert, {}, void 0);
    }
    else {
        renderAlert = (_jsx(Alert, Object.assign({}, rest, { className: className, color: type, isOpen: isVisible, toggle: dismissible ? handleToggle : undefined }, { children: renderAlertMessage() }), void 0));
    }
    return renderAlert;
};
export default TuxAlert;
